/**
 * common路由
 */
import { RouteConfig } from 'vue-router'

import { WhiteBarStyle } from '$utils/bar-style'
import { isPROD } from '$utils/common'

const routers: RouteConfig[] = []
if (!isPROD) {
  routers.push(
    {
      path: '/test/bury',
      meta: {
        title: '埋点测试',
        pullRefresh: true,
        barStyle: WhiteBarStyle,
        customerService: true,
      },
      component: () => import(/* webpackChunkName: "_bury_" */ '$burys/test.vue')
    },
  )
}

export default routers
